import ActionButton from "../atoms/ActionButton";

/**
 * ConfirmModal - 確認モーダル
 *
 * 画面中央に表示し、背後をオーバーレイで薄暗くする。
 * オーバーレイクリックでは閉じない（誤操作防止）。
 *
 * message が指定された場合はその文字列をそのまま表示する（汎用モード）。
 * type="noCheck":   売上額（差額計算用）が未入力のまま確定しようとした場合
 * type="diffFound": 売上（税込）差額・売上（税抜）差額の両方が非ゼロだった場合
 *
 * @param {string}   [message]         - 汎用メッセージ（指定時は type より優先）
 * @param {"noCheck"|"diffFound"} [type] - モーダルの種別（message 未指定時）
 * @param {number}   soUriageDiff      - 売上（税込）差額（diffFound 時に表示）
 * @param {number}   junUriageDiff     - 売上（税抜）差額（diffFound 時に表示）
 * @param {function} onConfirm         - 「確定する」押下ハンドラ
 * @param {function} onCancel          - 「キャンセル」押下ハンドラ
 */
// 差額表示用: 正の値には "+" を付与する
const formatSigned = (value) => (value > 0 ? "+" : "") + value.toLocaleString();

function ConfirmModal({ message, type, soUriageDiff, junUriageDiff, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg py-8 px-10 mx-4">
        {message != null ? (
          <p className="text-base text-gray-700 mb-6 whitespace-pre-line w-[44rem] max-w-[80vw]">{message}</p>
        ) : type === "noCheck" ? (
          <p className="text-base text-gray-700 mb-8">
            売上額（差額計算用）が未入力のため差額チェックが行われていません。
            <br />このまま確定しますか？
          </p>
        ) : (
          <>
            <p className="text-base text-gray-700 mb-4">
              差額が確認されました。入力に誤りがある可能性があります。
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded px-4 py-4 mb-4 text-base">
              <div className="flex justify-between gap-8">
                <span>総売上差額</span>
                <span>{formatSigned(soUriageDiff)} 円</span>
              </div>
              <div className="flex justify-between gap-8 mt-1">
                <span>純売上差額</span>
                <span>{formatSigned(junUriageDiff)} 円</span>
              </div>
            </div>
            <p className="text-base text-gray-700 mb-8">このまま確定しますか？</p>
          </>
        )}
        <div className="flex justify-center gap-12">
          <ActionButton
            label="キャンセル"
            onClick={onCancel}
            paddingClass="px-5 py-2"
            textSizeClass="text-base"
          />
          <ActionButton
            label="確定する"
            onClick={onConfirm}
            paddingClass="px-5 py-2"
            textSizeClass="text-base"
            colorClass="bg-gray-700 text-white"
          />
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
